var map = {
	"./amex.png": 937,
	"./diners.png": 938,
	"./discover.png": 939,
	"./jcb.png": 940,
	"./maestro.png": 1164,
	"./mastercard.png": 941,
	"./stripe.png": 942,
	"./union.png": 943,
	"./unknown.png": 622,
	"./visa.png": 944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1163;